export default "__VITE_ASSET__Nt419Vbv__"